export enum TracciatoFieldTypesEnum {
  standard = 1,
  fixed = 2,
  special = 3,
  skip = 4,
  external = 5,
  quality = 6,
  box = 7,
  causale = 8,
  movement = 9,
  registry = 10,
  ordineVendita = 11,
  ordineVenditaCampoUtente = 12,
  anagraficaCampoUtente = 13,
  ncCodice = 14,
  /** Feature 137: proprieta' anagrafica o flag operativo dell'operatore (OperatoreDto). */
  operatore = 15,
  /** Feature 137: campo utente dell'operatore — nome campo `CampoUtente.<CODICE>` dal picker dinamico. */
  operatoreCampoUtente = 16,
  /** Feature 138: proprietà del badge o anagrafica dell'intestatario (OperatoreBadgeDto). */
  operatoreBadge = 17,
  /**
   * Feature 138: campo utente della membership dell'intestatario — stesso ambito del canale
   * Operatori, perché i campi utente stanno sulla membership e non sul badge.
   */
  operatoreBadgeCampoUtente = 18
}

export const TRACCIATO_FIELD_TYPES = [
  { value: TracciatoFieldTypesEnum.standard, label: 'Standard' },
  { value: TracciatoFieldTypesEnum.fixed, label: 'Fisso' },
  { value: TracciatoFieldTypesEnum.special, label: 'Speciali' },
  { value: TracciatoFieldTypesEnum.skip, label: 'Salta' },
  { value: TracciatoFieldTypesEnum.external, label: 'Esterno' },
  { value: TracciatoFieldTypesEnum.quality, label: 'Controllo qualità'},
  { value: TracciatoFieldTypesEnum.box, label: 'Contenitori'},
  { value: TracciatoFieldTypesEnum.causale, label: 'Causali'},
  { value: TracciatoFieldTypesEnum.movement, label: 'Movimenti'},
  { value: TracciatoFieldTypesEnum.registry, label: 'Anagrafica'},
  { value: TracciatoFieldTypesEnum.ordineVendita, label: 'Ordine vendita'},
  { value: TracciatoFieldTypesEnum.ordineVenditaCampoUtente, label: 'Ordine vendita · Campo Utente'},
  { value: TracciatoFieldTypesEnum.anagraficaCampoUtente, label: 'Anagrafica · Campo Utente'},
  { value: TracciatoFieldTypesEnum.ncCodice, label: 'Codici NC'},
  { value: TracciatoFieldTypesEnum.operatore, label: 'Operatori'},
  { value: TracciatoFieldTypesEnum.operatoreCampoUtente, label: 'Operatori · Campo Utente'},
  { value: TracciatoFieldTypesEnum.operatoreBadge, label: 'Operatori · Badge'},
  { value: TracciatoFieldTypesEnum.operatoreBadgeCampoUtente, label: 'Operatori · Badge · Campo Utente'}
];
